import React, { useState } from 'react'
import '../SignUp/SignUp.scss'
import './AccountRecovery.scss'

import logo from '../../assets/images/DashboardImages/logo.svg'
import rightImg from '../../assets/images/DashboardImages/images/accountRecovery.png'
import emailIcon from '../../assets/images/DashboardImages/icons/mi_email.svg'
import { Link } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const AccountRecovery = () => {
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');


    const handleSubmit = (e) => {
        e.preventDefault();

        const isValid = validateInputs();
        if (!isValid) {
            if (emailError) {
                toast.error(emailError);
            }
            return;
        }
    };

    const validateInputs = () => {
        setEmailError('');
        if (!email || !emailRegex.test(email)) {
            setEmailError('Invalid email format');
        }

        return emailError === '';
    };
    return (
        <div>
            <img src={logo} alt='' className='logo-dash' />
            <form className='credentional-main-container' onSubmit={handleSubmit}>
                <div className='credentional-main-left-container'>
                    <div className='credentional-left-centered-container reset-left-centered-container'>
                        <h3>Account Recovery</h3>
                        <p>Regain access to your account with a<br /> secure password reset</p>
                        <h5>Enter you email</h5>
                        <span><img src={emailIcon} alt='' />
                            <input type='text' placeholder='Email' value={email} onChange={(e) => setEmail(e.target.value)} />
                        </span>
                        <button className='themebtn-1' type='submit'>Reset Password</button>
                        <p><Link to="/login" className='login-Link'>Back to Login</Link></p>
                    </div>
                </div>
                <div className='credentional-main-right-container'>
                    <img src={rightImg} alt='' />
                </div>
            </form>
            <ToastContainer position="top-right" autoClose={3000} />
        </div>
    )
}

export default AccountRecovery